import React, { useState } from 'react';
import './FeedView.css';

function FeedView({ patron, onFeed }) {
  const [text, setText] = useState('');
  const [emoji, setEmoji] = useState('✨');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const commonEmojis = ['✨', '💪', '🎯', '🌟', '☕', '💻', '🎵', '😊', '🌈', '🚀'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;

    setLoading(true);
    try {
      const data = await onFeed(text, emoji);
      if (data) {
        setResult(data);
        setText('');
        setEmoji('✨');
        setTimeout(() => setResult(null), 5000);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="feed-view">
      <div className="feed-card">
        <h2>📝 Накорми своего Патронуса</h2>
        <p className="feed-subtitle">Поделись хорошим моментом из своего дня</p>

        <form onSubmit={handleSubmit} className="feed-form">
          <div className="emoji-picker">
            <label>Выбери эмодзи (опционально):</label>
            <div className="emoji-grid">
              {commonEmojis.map((e) => (
                <button
                  key={e}
                  type="button"
                  className={`emoji-btn ${emoji === e ? 'active' : ''}`}
                  onClick={() => setEmoji(e)}
                >
                  {e}
                </button>
              ))}
            </div>
          </div>

          <div className="text-input">
            <textarea
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Например: 'Выпил вкусный кофе', 'Помог другу', 'Выспался хорошо'..."
              rows={4}
              disabled={loading}
            />
          </div>

          <button type="submit" disabled={!text.trim() || loading} className="submit-btn">
            {loading ? '⏳ Подожди...' : '🌟 Накормить'}
          </button>
        </form>

        {result && (
          <div className="result-message success">
            <h3>🎉 {result.message}</h3>
            {result.keywords && result.keywords.length > 0 && (
              <div className="keywords">
                <p>✨ Найдены совпадения:</p>
                <ul>
                  {result.keywords.map((kw, i) => (
                    <li key={i}>{kw}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="suggestions">
        <h3>💡 Примеры впечатлений:</h3>
        <div className="suggestion-grid">
          <div className="suggestion">
            <span>💪</span>
            <p>Сделал зарядку</p>
          </div>
          <div className="suggestion">
            <span>📚</span>
            <p>Прочитал интересную статью</p>
          </div>
          <div className="suggestion">
            <span>🤝</span>
            <p>Помог другу</p>
          </div>
          <div className="suggestion">
            <span>🌟</span>
            <p>Достиг своей цели</p>
          </div>
          <div className="suggestion">
            <span>😊</span>
            <p>Хорошо выспался</p>
          </div>
          <div className="suggestion">
            <span>🎵</span>
            <p>Слушал музыку</p>
          </div>
        </div>
      </div>

      <div className="tip-box">
        <p>🔮 <strong>Совет:</strong> Чем разнообразнее твои впечатления, тем больше бонусов ты получишь!</p>
      </div>
    </div>
  );
}

export default FeedView;
